'use client';
import { useEffect, useState, Suspense } from 'react';
import { Hydrate, QueryClient, QueryClientProvider } from 'react-query';
// import { ReactQueryDevtools } from 'react-query/devtools';

import { TNavigation } from '@/lib/sanity/queries/navigationQuery';

import { NavigationProvider } from '@/contexts/navigation';

import '@fagmobler/config/styles/global.css';
import '@/styles/googlemaps.css';

import { usePathname, useSearchParams } from 'next/navigation';
import { trackPage } from '@/lib/analytics';
import DefaultLayout from '@/components/layout';
import {
  ALGOLIA_APPLICATION_ID,
  ALGOLIA_SEARCH_API_KEY,
} from '@/lib/algolia/searchClient';
import Growthbook from '@/lib/growthbook';
import { VisualEditing } from 'next-sanity';

function ClientLayoutContent({
  children,
  navigation,
}: {
  children: React.ReactNode;
  navigation?: TNavigation;
}) {
  const pathname = usePathname();
  const searchParams = useSearchParams();
  const [queryClient] = useState(
    () =>
      new QueryClient({
        // defaultOptions: {
        //   queries: {
        //     cacheTime: 1000 * 60 * 5, // 5 minutes
        //     staleTime: 1000 * 5, // 5 seconds,
        //   },
        // },
      })
  );

  // Track page views when the pathname or search params change
  useEffect(() => {
    trackPage({ pathname, searchParams });
  }, [pathname, searchParams]);

  useEffect(() => {
    if (window.aa) {
      window.aa('init', {
        appId: ALGOLIA_APPLICATION_ID,
        apiKey: ALGOLIA_SEARCH_API_KEY,
      });
      console.log('loaded', window.aa);
    } else {
      console.error('no window.aa');
    }
  }, []);

  return (
    <Growthbook>
      <QueryClientProvider client={queryClient}>
        <NavigationProvider {...navigation}>
          <DefaultLayout>{children}</DefaultLayout>
        </NavigationProvider>
      </QueryClientProvider>
    </Growthbook>
  );
}

export default function ClientLayout({
  children,
  navigation,
}: {
  children: React.ReactNode;
  navigation?: TNavigation;
}) {
  return (
    <Suspense>
      <ClientLayoutContent navigation={navigation}>
        {children}
      </ClientLayoutContent>
    </Suspense>
  );
}
